import React, { isValidElement, JSX } from 'react'
import './index.scss'
import SelectComponent, { SelectOption } from '@Components/Selectors/Select'
import FieldErrorSection from '@Components/Fields/FieldErrorSection'
import clsx from 'clsx'

interface DropdownProps {
    mainColor: boolean
    options: SelectOption[]
    isDisabled?: boolean
    selectedValue?: SelectOption | null
    defaultValue?: SelectOption | null
    placeholder?: string
    label?: string
    assistiveText?: string
    className?: string
    autoComplete?: 'on' | 'off'
    isPhoneCodeType?: boolean
    isBorder?: boolean
    small?: boolean
    errorMessage?: string
    isClearable?: boolean
    isSearchable?: boolean
    onSelect?(e: any): void
    required?: boolean
    id?: string
    onChange?: (value: string | number, id: string) => void
    isNumberType?: boolean
    tooltip?: JSX.Element
}

const Dropdown = ({
    mainColor = true,
    options,
    isDisabled,
    selectedValue,
    defaultValue,
    placeholder,
    label,
    assistiveText,
    className,
    isPhoneCodeType,
    isBorder,
    small,
    errorMessage,
    isClearable,
    isSearchable,
    required,
    onSelect = () => {},
    onChange,
    id,
    isNumberType,
    tooltip,
}: DropdownProps) => {
    const handleChange = (data: SelectOption) => {
        let value: string | number

        if (isNumberType) {
            value = data && data.id ? Number(data.id) : 0
        } else {
            value = data && data.label ? data.label : ''
        }

        onChange && id && onChange(value || '', id || '')
    }

    const classNames = clsx(
        'dropdown-component',
        mainColor ? 'main-color-set' : 'second-color-set',
        isPhoneCodeType && 'phone-code-type',
        isBorder && 'border',
        small && 'small',
        errorMessage && 'error',
        className
    )

    return (
        <div className={classNames} data-testid="dropdown-component">
            {selectedValue && label && <label className="label">{label}</label>}
            <SelectComponent
                onValueChange={onChange ? handleChange : onSelect}
                options={options}
                isDisabled={isDisabled}
                selectedValue={selectedValue}
                placeholder={placeholder ? placeholder : label}
                defaultValue={defaultValue}
                isClearable={isClearable}
                isSearchable={isSearchable}
            />
            {isValidElement(tooltip) && tooltip}
            <FieldErrorSection errorMessage={errorMessage} assistiveText={assistiveText} required={required} />
        </div>
    )
}

export default Dropdown
